import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ROLES } from '../constants/roles.constants';

@Injectable({
  providedIn: 'root'
})
export class PraticienGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const user = this.authService.getCurrentUser();
    
    if (!user) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    // Le rôle kiné utilise le même parcours applicatif que le praticien.
    const roleName = user.role?.nom?.toLowerCase();
    const hasPraticienRole = roleName === ROLES.PRATICIEN || roleName === ROLES.KINE;
    
    if (!hasPraticienRole) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    return true;
  }
}
